"use client"
import "./globals.css"
import ErrorPage from "./[locale]/[currency]/[persona]/error"
import "../components/offline/SeaRunner"

type GlobalErrorProps = {
  error: Error & { digest?: string }
}

export default function GlobalError({ error }: GlobalErrorProps) {
  return (
    <html lang="en">
      <body>
        <ErrorPage error={error} />
      </body>
    </html>
  )
}
